import React from 'react'
import PropTypes from 'prop-types'
import { Paragraph } from '@fs/zion-ui'

import { css } from '@emotion/core'
import styles from './ProjectStatus.styles'
import transl from './ProjectStatus.transl'

const rowLevelHeadersCss = css`
  font-weight: bold;
  word-break: normal;
  overflow-wrap: normal;
`

function StatusIcon({ status }) {
  switch (status) {
    case 'AVAILABLE':
      return (
        <span aria-label={transl.currentStatusAriaLabel()} css={styles.icon('orange')} data-testid="statusOrange" />
      )
    case 'INGEST_FAILED':
      return <span aria-hidden css={styles.icon('red')} data-testid="statusRed" />
    case 'COMPLETED':
      return <span aria-label={transl.currentStatusAriaLabel()} css={styles.icon('green')} data-testid="statusGreen" />
    case 'INGEST_SUCCESS':
      return <span aria-hidden css={styles.icon('green')} data-testid="statusGreen" />
    case 'IN_PROGRESS':
      return <span data-testid="statusBlue" aria-label={transl.currentStatusAriaLabel()} css={styles.icon('blue')} />
    default:
      return <span aria-label="status red" css={styles.icon('red')} data-testid="statusRed" />
  }
}

StatusIcon.propTypes = {
  status: PropTypes.string,
}

const MemoizedStatusIcon = React.memo(StatusIcon)

function ProjectStatus({ status = 'AVAILABLE', showStatusIcon = true }) {
  // Convert the status we get from GraphQL for Front End use
  const translatedStatusMapping = {
    AVAILABLE: transl.notStarted(),
    COMPLETED: transl.completed(),
    IN_PROGRESS: transl.production(),
    INGEST: transl.overallStatus(),
  }
  const statusKey = translatedStatusMapping[status] ? status : 'INGEST'
  return (
    <div data-testid={`camera-project-status-${statusKey}`} css={styles.container()}>
      <section css={styles.iconContainer(!showStatusIcon)}>
        {showStatusIcon && <MemoizedStatusIcon status={status} />}
      </section>
      {/* overall status for the ingest table */}
      <Paragraph size="sm">
        <span css={rowLevelHeadersCss}>{translatedStatusMapping[statusKey]}</span>
      </Paragraph>
    </div>
  )
}

ProjectStatus.propTypes = {
  status: PropTypes.string,
}

export default React.memo(ProjectStatus)
